import {useEffect} from 'react'
import {useFormik} from 'formik'
import Swal from 'sweetalert2'
import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {RoomFormProvider, useRoomForm} from './core/RoomFormProvider'
import {RoomForm} from './components/RoomForm'
import {roomSchema} from './core/validation/roomVali'
import {BuildRequest} from './core/BuildRequest'
import {createRoom} from './core/_request'
import {showRequestError} from './core/showRequestError'
import {TAdminRoomForm, TAdminRoomRequest} from './core/_models'

const roomBreadcrumbs: Array<PageLink> = [
  {
    title: 'Admin',
    path: '/admin/rooms',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const initialValues: TAdminRoomForm = {
  franchise: null,
  name: '',
  syncName: '',
  color: '#000000',
  categories: [],
  products: [],
  machines: [],
  intervals: [],
  maxScheduleDate: 0,
}

const Create = () => {
  const {navigate, setLoading, getDataFranchises, getDataCategories} = useRoomForm()

  useEffect(() => {
    getDataFranchises()
    getDataCategories()
  }, [])

  const formik = useFormik<TAdminRoomForm>({
    initialValues,
    validationSchema: roomSchema,
    onSubmit: (values) => submit(BuildRequest(values)),
  })

  const submit = async (req: TAdminRoomRequest) => {
    const result = await Swal.fire({
      title: 'Deseja salvar a sala?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-secondary',
      },
    })
    if (!result.isConfirmed) return

    setLoading(true)
    try {
      await createRoom(req)
      await Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Salvo com sucesso',
        showConfirmButton: false,
        timer: 1500,
      })
      navigate('/admin/rooms', {replace: true})
    } catch (error: any) {
      await showRequestError(error)
    } finally {
      setLoading(false)
    }
  }

  return <RoomForm formik={formik} />
}

export const RoomCreatePage = () => {
  return (
    <>
      <PageTitle breadcrumbs={roomBreadcrumbs}>Criar Sala</PageTitle>
      <RoomFormProvider>
        <Create />
      </RoomFormProvider>
    </>
  )
}
